import { convertTimeToMinutes } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertTimeToMinutes',
  standalone: true
})
export class ConvertTimeToMinutesPipe implements PipeTransform {

  transform(dateTimeString: string): number {
    return convertTimeToMinutes(dateTimeString);
  }

}
